export type TariffFeatures = {
  base: string[];
  pro: string[];
};

export const TARIFF_FEATURES_BY_LOCALE: Record<string, TariffFeatures> = {
  ru: {
    base: [
      'Запись и календарь',
      'Управление графиком',
      'База клиентов и история визитов',
      'Онлайн-запись для клиентов по ссылке',
      'Перенос и отмена записи без переписок',
      'Автоматические уведомления клиентам (VK, Telegram, Email)',
      'Оффлайн режим (просмотр записей)',
    ],
    pro: [
      'Все функции Базового',
      'Расширенные напоминания клиентам',
      'Бот-администратор в VK',
      'Ответы на вопросы клиентов об услугах и ценах',
      'Расширенная аналитика и отчёты',
    ],
  },
  en: {
    base: [
      'Booking and calendar',
      'Client base and visit history',
      'Booking management by link (cancel / reschedule)',
      'VK booking notifications',
      'VK bot: my bookings, cancel, reschedule',
    ],
    pro: [
      'All Base features',
      'Extended client reminders',
      'VK admin bot',
      'Answers on services, prices and rules',
      'Analytics and reports',
    ],
  },
  uz: {
    base: [
      'Yozuvlar va taqvim',
      'Mijozlar bazasi va tashriflar tarixi',
      "Havola orqali yozuvni boshqarish (bekor qilish / ko‘chirish)",
      "VK'da yozuvlar haqida bildirishnomalar",
      "VK bot: mening yozuvlarim, bekor qilish, ko‘chirish",
    ],
    pro: [
      "Base'ning barcha funksiyalari",
      'Mijozlar uchun kengaytirilgan eslatmalar',
      "VK'da admin-bot",
      'Xizmatlar, narxlar va qoidalar bo‘yicha javoblar',
      'Analitika va hisobotlar',
    ],
  },
  tg: {
    base: [
      'Сабт ва тақвим',
      'Пойгоҳи муштариён ва таърихи боздидҳо',
      'Идоракунии сабт тавассути истинод (бекоркунӣ / интиқол)',
      'Огоҳӣ дар бораи сабт дар VK',
      'VK бот: сабтҳои ман, бекоркунӣ, интиқол',
    ],
    pro: [
      'Ҳамаи имкониятҳои Base',
      'Ёдраскуниҳои васеъ барои муштариён',
      'Бот-администратор дар VK',
      'Ҷавобҳо дар бораи хизматҳо, нархҳо ва қоидаҳо',
      'Аналитика ва ҳисоботҳо',
    ],
  },
  ky: {
    base: [
      'Жазуулар жана календарь',
      'Кардарлар базасы жана визит тарыхы',
      'Шилтеме аркылуу жазууну башкаруу (жокко чыгаруу / жылдыруу)',
      'VKда жазуулар тууралуу эскертмелер',
      'VK бот: менин жазууларым, жокко чыгаруу, жылдыруу',
    ],
    pro: [
      "Base'тин бардык функциялары",
      'Кардарларга кеңейтилген эскертмелер',
      'VKдагы админ-бот',
      'Кызматтар, баалар жана эрежелер боюнча жооптор',
      'Аналитика жана отчеттор',
    ],
  },
  az: {
    base: [
      'Qeydiyyat və təqvim',
      'Müştəri bazası və ziyarət tarixi',
      'Linklə qeydiyyatın idarəsi (ləğv / dəyişmə)',
      'VK-də qeydiyyat bildirişləri',
      'VK bot: qeydlərim, ləğv, dəyişmə',
    ],
    pro: [
      "Base-in bütün funksiyaları",
      'Müştərilər üçün genişləndirilmiş xatırlatmalar',
      'VK admin botu',
      'Xidmətlər, qiymətlər və qaydalar üzrə cavablar',
      'Analitika və hesabatlar',
    ],
  },
  hy: {
    base: [
      'Գրանցումներ և օրացույց',
      'Հաճախորդների բազա և այցերի պատմություն',
      'Գրանցման կառավարում հղումով (չեղարկում / տեղափոխում)',
      'Գրանցումների մասին ծանուցումներ VK-ում',
      'VK բոտ՝ իմ գրանցումները, չեղարկում, տեղափոխում',
    ],
    pro: [
      'Base-ի բոլոր հնարավորությունները',
      'Հաճախորդների համար ընդլայնված հիշեցումներ',
      'VK ադմին բոտ',
      'Ծառայությունների, գների և կանոնների վերաբերյալ պատասխաններ',
      'Վերլուծություն և հաշվետվություններ',
    ],
  },
};

export function getTariffFeatures(locale: string): TariffFeatures {
  const key = locale.split('-')[0];
  return TARIFF_FEATURES_BY_LOCALE[key] ?? TARIFF_FEATURES_BY_LOCALE.ru;
}
